import PropTypes from "prop-types"
import { Close } from "@mui/icons-material"
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material"
import "./style.scss"

export default function FullSizeArtifactDialog({ open, onClose, title, children, actions }) {
  if (!open) {
    return null
  }

  return <Dialog
    className="full-size-artifact-dialog"
    maxWidth="xl"
    fullWidth
    open={open}
    onClose={onClose}
    slotProps={{
      paper: {
        className: "full-size-artifact-dialog-container",
      },
    }}
  >
    <DialogTitle className="dialog-title">
      {title}
      <div className="dialog-title-actions">
        {actions}
        <IconButton
          className="close-button"
          aria-label="close"
          onClick={onClose}
        >
          <Close />
        </IconButton>
      </div>
    </DialogTitle>
    <DialogContent className="dialog-content">{children}</DialogContent>
  </Dialog>
}

FullSizeArtifactDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  actions: PropTypes.node,
}
